<div [id]="data?.layoutData?.uuid" *ngIf="!showPreview" class="add-video-wrapper w-full">
  <app-text-input (checkForErrors)="checkForErrors($event)" [error]="errorMessages['videoUrl']"
                  [maxLength]="100000" [parentFormGroup]="videoForm"
                  class="resource-input" controlName="videoUrl"
                  placeholder="Enter Video URL" type="small"></app-text-input>
</div>

<div [id]="data?.layoutData?.uuid" *ngIf="showPreview" class="add-video-wrapper-preview w-full">
  <div class="w-full flex items-center input-wrapper justify-around">
    <div class="w-[85%]">
      <app-text-input (checkForErrors)="checkForErrors($event)" [error]="errorMessages['videoUrl']"
                      [maxLength]="100000" [parentFormGroup]="videoForm"
                      [readonly]="false"
                      class="preview-input" controlName="videoUrl" placeholder="Enter Presentation URL"
                      type="small"></app-text-input>
    </div>
    <div class="w-[10%]">
      <app-icon (click)="deleteGoogleSlidesLink()" class="delete-bold-icon cursor-pointer"
                svgIcon="delete-bold"></app-icon>
    </div>
  </div>
  <div *ngIf="videoForm?.value?.videoUrl.length>0 && showPreview"
       [innerHTML]="getSanitizedContent(videoForm?.value?.videoUrl)"
       class="video-wrapper-{{UUID}} preview"></div>
</div>
